import api from '../utils/api'; 
export const fetchUniqueStreams = async () => {
  const response = await api.get('/streams');
  return response.data;
};